"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Divider.css");
var Divider = (function (_super) {
    __extends(Divider, _super);
    function Divider(props) {
        return _super.call(this, props) || this;
    }
    Divider.prototype.render = function () {
        var cssClass = ['p-divider'];
        var attrs = {};
        if (this.props.gutter !== Divider.defaultProps.gutter) {
            var cases_1 = {
                'Zero': 'divider-gutter-none',
                'Xsmall': 'divider-gutter-xs',
                'Small': 'divider-gutter-sm',
                'Medium': 'divider-gutter-md',
                'Large': 'divider-gutter-lg',
                'Xlarge': 'divider-gutter-xl',
            };
            cssClass.push(cases_1[this.props.gutter]);
        }
        if (this.props.height !== Divider.defaultProps.height) {
            var cases_2 = {
                'Small': 'divider-sm',
                'Medium': 'divider-md',
                'Large': 'divider-lg',
                'Xlarge': 'divider-xl'
            };
            cssClass.push(cases_2[this.props.height]);
        }
        var cases = {
            'White': 'p-bc-b-white',
            'Grey20': 'p-bc-b-grey20',
            'Grey30': 'p-bc-b-grey30',
            'Grey40': 'p-bc-b-grey40',
            'Grey50': 'p-bc-b-grey50',
            'Grey60': 'p-bc-b-grey60',
            'Grey70': 'p-bc-b-grey70',
            'Grey80': 'p-bc-b-grey80',
            'Primary': 'p-bc-b-primary50',
            'Secondary': 'p-bc-b-secondary50'
        };
        cssClass.push(cases[this.props.color]);
        if (this.props.marginBottom !== Divider.defaultProps.marginBottom) {
            var cases_3 = {
                'Xsmall': 'divider-margin-bottom-xs',
                'Small': 'divider-margin-bottom-sm',
                'Medium': 'divider-margin-bottom-md',
                'Large': 'divider-margin-bottom-lg',
                'Xlarge': 'divider-margin-bottom-xl'
            };
            cssClass.push(cases_3[this.props.marginBottom]);
        }
        if (this.props.marginTop !== Divider.defaultProps.marginTop) {
            var cases_4 = {
                'Xsmall': 'divider-margin-top-xs',
                'Small': 'divider-margin-top-sm',
                'Medium': 'divider-margin-top-md',
                'Large': 'divider-margin-top-lg',
                'Xlarge': 'divider-margin-top-xl',
            };
            cssClass.push(cases_4[this.props.marginTop]);
        }
        if (this.props.tag != null)
            attrs["data-tag"] = this.props.tag;
        return React.createElement("div", __assign({ className: cssClass.join(' ') }, attrs));
    };
    return Divider;
}(React.Component));
Divider.defaultProps = {
    tag: null,
    color: "Grey50",
    height: "Default",
    gutter: "None",
    marginTop: "None",
    marginBottom: "None"
};
exports.Divider = Divider;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['Divider'] = Divider;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Divider"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Divider/Divider.js
// module id = 354
// module chunks = 0 1